import * as React from 'react';
import { Header } from '../components/Shared/Header/Header'
import { Footer } from '../components/Shared/Footer'
import { Outlet } from 'react-router-dom';
import { Banner } from '../components/Shared/Banner';

export const Layout = () => {

    return (
        <div className="page">
            <Banner />
            <Header />
            <Outlet/>
            <Footer />
        </div>
    );
};
